"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASSI_BASIC_ACCESS = exports.COGS_CLOUD_SUPPORT = exports.COGS_SITE_SUPPORT = exports.SALES_CHANNEL = exports.SALES_CA_SME = exports.COGS_BITBUCKET_CLOUD_SUPPORT = exports.RD_ENGG_GROWTH = exports.RD_ENGG_ENTERPRISE_CLOUD = exports.MKTG_GTM_SUPPORT = exports.CASSI_DEVELOPER = exports.GOVERNATOR_ADMIN = exports.COMMERCE_DEV = exports.SALES_OPERATIONS = exports.CST_DEVELOPER = exports.CONTRACT_ADVOCATE = exports.DEVELOPER_ADVOCATE = exports.PRODUCT_ADVOCATE = exports.DEAL_DESK = exports.LOYALTY_ADVOCATE = exports.ENTERPRISE_ADVOCATE = exports.CUSTOMER_ADVOCATE = void 0;
exports.CUSTOMER_ADVOCATE = 'CUSTOMER_ADVOCATE';
exports.ENTERPRISE_ADVOCATE = 'ENTERPRISE_ADVOCATE';
exports.LOYALTY_ADVOCATE = 'LOYALTY_ADVOCATE';
exports.DEAL_DESK = 'DEAL_DESK';
exports.PRODUCT_ADVOCATE = 'PRODUCT_ADVOCATE';
exports.DEVELOPER_ADVOCATE = 'DEVELOPER_ADVOCATE';
exports.CONTRACT_ADVOCATE = 'CONTRACT_ADVOCATE';
exports.CST_DEVELOPER = 'CST_DEV';
exports.SALES_OPERATIONS = 'SALES_OPS';
exports.COMMERCE_DEV = 'COMMERCE_DEV';
exports.GOVERNATOR_ADMIN = 'GOVERNATOR_ADMIN';
exports.CASSI_DEVELOPER = 'CASSI_DEVELOPER';
exports.MKTG_GTM_SUPPORT = 'MKTG_GTM_SUPPORT';
exports.RD_ENGG_ENTERPRISE_CLOUD = 'RD_ENGG_ENTERPRISE_CLOUD';
exports.RD_ENGG_GROWTH = 'RD_ENGG_GROWTH';
exports.COGS_BITBUCKET_CLOUD_SUPPORT = 'COGS_BITBUCKET_CLOUD_SUPPORT';
exports.SALES_CA_SME = 'SALES_CA_SME';
exports.SALES_CHANNEL = 'SALES_CHANNEL';
exports.COGS_SITE_SUPPORT = 'COGS_SITE_SUPPORT';
exports.COGS_CLOUD_SUPPORT = 'COGS_CLOUD_SUPPORT';
exports.CASSI_BASIC_ACCESS = 'CASSI_BASIC_ACCESS';
